const SET_ERROR = (state, errors) => {
  state.errors = errors;
};

const SET_CLASS_LIST = (state, data) => {
  state.classList = data.data;
};

const SET_SUBJECT_DETAIL = (state, data) => {
  state.subject = data.data;
}

const SET_QUESTION_CORRECT = (state, data) => {
  if (data.is_correct) {
    state.questionCorrected++;
  }
}

const SET_QUESTION_DETAIL = (state, data) => {
  if (!data) {
    if (state.questionIndex == 0) {
      state.isPrev = false;
    } else {
      state.isNext = false;
    }
    return;
  }
  let temp;
  // For group questions
  // if (question.type == 103 || question.type == 104 || question.type == 155) {
  if (data.type_enum == 'group') {
    temp = {
      id: data.id,
      type: data.type,
      typeEnum: data.type_enum,
      audio: data.attachment_audio,
      image: data.attachment_image,
      content: data.content,
      explain: data.explain,
      images: data.image_group,
      timeHidden: data.time_hidden,
      children: [],
      response: null
    }

    let questionCount = 0;
    data.children.forEach(childQuestion => {
      questionCount++;
      // Add data list
      temp.children.push({
        id: childQuestion.id,
        number: questionCount,
        type: childQuestion.type,
        typeEnum: childQuestion.type_enum,
        audio: childQuestion.attachment_audio,
        image: childQuestion.attachment_image,
        content: childQuestion.content,
        images: childQuestion.image_group,
        timeHidden: childQuestion.time_hidden,
        answers: childQuestion.answers,
        explain: childQuestion.explain ? childQuestion.explain : "Đang bổ sung giải thích cho câu trả lời."
      });
    });
  } else {
    temp = {
      id: data.id,
      type: data.type,
      typeEnum: data.type_enum,
      audio: data.attachment_audio,
      image: data.attachment_image,
      content: data.content,
      images: data.image_group,
      timeHidden: data.time_hidden,
      answers: data.answers,
      response: null,
      explain: data.explain ? data.explain : "Đang bổ sung giải thích cho câu trả lời."
    }
  }

  const tempIndex = state.questionList.findIndex(item => item.id == temp.id);
  console.log('Find Index', tempIndex);
  state.questionId = data.id;
  if (tempIndex == -1) {
    if (state.action == 'next') {
      state.questionList.push(temp);
      state.questionIndex = state.questionList.length - 1;
    } else if (state.action == 'prev') {
      state.questionList.unshift(temp);
      state.questionIndex = 0;
    } else {
      state.questionList.push(temp);
      state.questionIndex = 0;
    }
  } else {
    if (state.action == 'next') {
      state.isNext = false;
    } else {
      state.isPrev = false;
    }
  }
}

const SET_CLASS_STATISTIC = (state, data) => {
  state.statistics = data;
}

const SET_QUESTION_LIST = (state, data) => {
  state.questionList = data;
}

const CLEAR_QUESTION = (state) => {
  state.question = null;
}

const CLEAR_QUESTION_LIST = (state) => {
  state.questionList = [];
}

const SET_QUESTION_INDEX = (state, data) => {
  state.questionIndex = data;
  state.questionId = state.questionList[state.questionIndex].id;
}

const SET_QUESTION_ACTION = (state, data) => {
  state.action = data;
}

export default {
  SET_ERROR,
  SET_CLASS_LIST,
  SET_CLASS_STATISTIC,
  SET_SUBJECT_DETAIL,
  SET_QUESTION_DETAIL,
  SET_QUESTION_LIST,
  SET_QUESTION_CORRECT,
  CLEAR_QUESTION,
  CLEAR_QUESTION_LIST,
  SET_QUESTION_INDEX,
  SET_QUESTION_ACTION
};